import { ref, onMounted } from 'vue'
import { ItemWrapper } from '@/wrappers'
import { UserIcon } from '@heroicons/vue/24/outline'
import type { Employee, FormData, FormInfo, DataFile, FormSelectOption, RequestType } from '@/interfaces'

export function useEmployees(skipLoading: boolean = false) {

    const baseForm: FormData = {
        frontLetters: null,
        lastName: null,
        dayOfBirth: null,
        nationalIdType: null,
        nationalId: null
    };

    const wrapper = new ItemWrapper<Employee>("employees");

    const empty = {...baseForm};

    const request = ref<RequestType<FormData>>({
        isLoading: false,
        error: null,
        response: null,
        data: baseForm
    });

    const info = ref<FormInfo>();
    const employees = ref<Employee[]>([]);
    const employeeOptions = ref<FormSelectOption[]>([]);

    async function addEmployee(): Promise<void> {
        request.value = {...request.value , error: null , response: null , isLoading: !request.value.isLoading};

        await wrapper.addItem(getData()).then((data) => request.value.response = data.message)
            .catch((err) => request.value.error = err.response.data.message);

        request.value.data = {...empty};
        request.value.isLoading = !request.value.isLoading;
    }

    function getAsFormOptions(): void {
        employeeOptions.value = employees.value.map(employee => {
            return {
                value: employee.id,
                label: `${employee.frontLetters} ${employee.lastName}`,
                icon: UserIcon
            }
        });
    }

    async function getEmployees(): Promise<void> {
        request.value.isLoading = !request.value.isLoading;

        await wrapper.getItems().then((data) => employees.value = data);

        getAsFormOptions();
        request.value.isLoading = !request.value.isLoading;
    }

    async function getInfo(): Promise<void> {
        request.value.isLoading = !request.value.isLoading;

        await wrapper.getInfo().then((data) => info.value = data);

        request.value.isLoading = !request.value.isLoading;
    }

    function getData(): DataFile {
        return {
            file: null,
            data: JSON.stringify(request.value.data)
        }
    }


    onMounted(() => {
        if (skipLoading) return;

        getEmployees();
    });

    return {
        info,
        request,
        employees,
        employeeOptions,
        addEmployee,
        getInfo,
        getEmployees
    }
}